module.exports = __webpack_public_path__ + "img/notes-icon.aec95d4e.svg";